import axios from 'axios';

const projectAPI = axios.create({
  baseURL: 'https://missionmap-lc.onrender.com/api/leave',
});

projectAPI.interceptors.request.use((config) => {
  const token = localStorage.getItem('token'); // JWT token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`; // ✅ Attach token
  }
  return config;
});

export default projectAPI;
